import type { JobPosition, Nurse, Team, UserContactProfile } from "@dutyon/apis";
import { Badge, Group, getPositionName, Paper, RoleBadge, Table, Text } from "@dutyon/ui-kit";

interface CompanyNurseListProps {
  nurses?: (Nurse & {
    user: UserContactProfile;
    team: Team | null;
    position?: JobPosition | null;
  })[];
  formatDate: (date: Date | string) => string;
}

export function CompanyNurseList({ nurses, formatDate }: CompanyNurseListProps) {
  return (
    <Paper withBorder p="md">
      {!nurses || nurses.length === 0 ? (
        <Text c="dimmed">등록된 사용자가 없습니다.</Text>
      ) : (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>이름</Table.Th>
              <Table.Th>이메일</Table.Th>
              <Table.Th>직책/역할</Table.Th>
              <Table.Th>가입일</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {nurses.map((nurse) => (
              <Table.Tr key={nurse.id}>
                <Table.Td style={{ fontWeight: 500 }}>{nurse.user?.name}</Table.Td>
                <Table.Td>{nurse.user?.email}</Table.Td>
                <Table.Td>
                  <Group gap="xs">
                    <Text size="sm">{getPositionName(nurse.position)}</Text>
                    <RoleBadge role={nurse.role} />
                    {nurse.team ? (
                      <Badge variant="dot" color="blue">
                        {nurse.team.name}
                      </Badge>
                    ) : (
                      <Badge variant="outline" color="gray">
                        팀 미배정
                      </Badge>
                    )}
                  </Group>
                </Table.Td>
                <Table.Td>{nurse.joinDate ? formatDate(nurse.joinDate) : "-"}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Paper>
  );
}
